import { useCallback } from "react";
import { cn } from "../../utils/classNames";
import XButton from "./XButton";
import { useDrawerContext } from "../../contexts/DrawerContext";
import DrawerCollapseIcon from "../../assets/icons/drawerCollapse.svg?react";

const rootClasses = "flex items-stretch";

const asideClasses = "relative sticky shrink-0 transition-[width] duration-300 ease-in-out top-0 h-screen -mt-[60px] bg-primary-dark-2";

const panelFrameClasses = "h-full w-full overflow-hidden rounded-r-md";

const scrollAreaClasses = "scrollbar-transparent h-full w-[35vw] overflow-y-auto overscroll-contain transition-opacity duration-200 [direction:ltr]";

const hostClasses = "min-h-full w-full p-6 pb-[100px] text-white [direction:ltr]";

const drawerCollapseClasses = "absolute top-6 right-0 z-10 translate-x-1/2 p-3! rounded-full! bg-primary! hover:bg-primary-hover! shadow-lg shadow-black/20";

const contentClasses = "flex-1 min-w-0 transition-[margin] duration-300 ease-in-out";

const Drawer = ({ children }) => {
    const { isDrawerOpen, isShowDrawerPanel, toggleDrawerPanel, setDrawerSidePanel } = useDrawerContext();

    const hostRef = useCallback((node) => setDrawerSidePanel(node), [setDrawerSidePanel]);

    return (
        <div className={rootClasses}>
            {isShowDrawerPanel && (
                <aside
                    className={cn(asideClasses, isDrawerOpen ? "w-[var(--drawer-width)]" : "w-0")}
                >
                    <div className={panelFrameClasses}>
                        <div className={scrollAreaClasses}>
                            <div ref={hostRef} className={hostClasses} />
                        </div>
                    </div>

                    {isDrawerOpen && (
                        <XButton
                            variant="link"
                            onClick={toggleDrawerPanel}
                            className={drawerCollapseClasses}
                        >
                            <DrawerCollapseIcon />
                        </XButton>
                    )}
                </aside>
            )}

            <div className={cn(contentClasses, isShowDrawerPanel && isDrawerOpen && "ml-4")}>{children}</div>
        </div>
    );
};

export default Drawer;
